<app-info-line [icon]="icon" [text]="location()" [additionalClasses]="additionalClasses()" />
